export default __webpack_public_path__ + "static/media/logoWOGD-Bright-No-Shadow.6e4a0da5.png";